import { useState } from 'react';
import AmbientBackground from '@/components/AmbientBackground';
import Button from '@/components/Button';
import Input from '@/components/Input';
import { entrar } from './api';

function LeafMark({ size = 40 }: { size?: number }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} fill="var(--moss-300)" aria-hidden>
      <path d="M50 86 L 44 64 L 48 50 L 44 30 L 50 8 L 56 30 L 52 50 L 56 64 Z" />
      <path d="M50 86 L 44 70 L 48 56 L 44 38 L 50 18 L 56 38 L 52 56 L 56 70 Z" transform="rotate(-32 50 86)" />
      <path d="M50 86 L 44 70 L 48 56 L 44 38 L 50 18 L 56 38 L 52 56 L 56 70 Z" transform="rotate(32 50 86)" />
      <path d="M50 86 L 44 74 L 48 62 L 44 48 L 50 30 L 56 48 L 52 62 L 56 74 Z" transform="rotate(-62 50 86)" />
      <path d="M50 86 L 44 74 L 48 62 L 44 48 L 50 30 L 56 48 L 52 62 L 56 74 Z" transform="rotate(62 50 86)" />
    </svg>
  );
}

export default function LoginScreen({ onEntrou }: { onEntrou: () => void }) {
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | undefined>();
  const [carregando, setCarregando] = useState(false);

  async function submeter(e: React.FormEvent) {
    e.preventDefault();
    if (carregando) return;
    setErro(undefined);
    setCarregando(true);
    try {
      await entrar(senha);
      onEntrou();
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Não foi possível entrar.');
      setSenha('');
      setCarregando(false);
    }
  }

  return (
    <div className="app-shell relative min-h-screen w-full flex items-center justify-center">
      <AmbientBackground petals={6} />
      <form
        onSubmit={submeter}
        className="relative z-[1] w-[min(92vw,360px)] flex flex-col items-center gap-s6 rounded-md border border-[var(--border)] bg-card px-s7 py-s8 animate-dialogIn"
        style={{ boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }}
      >
        <div className="flex flex-col items-center gap-s3 text-center">
          <LeafMark />
          <div className="flex flex-col leading-none">
            <span className="font-display italic text-[26px] text-fg-1 leading-none">Floricultura</span>
            <span className="font-body text-[11px] uppercase tracking-[0.24em] text-fg-3 mt-[5px]">
              Noturna
            </span>
          </div>
        </div>

        <p className="font-display italic text-[15px] text-fg-3 text-center leading-snug">
          O jardim está trancado. Diga a senha.
        </p>

        <div className="w-full flex flex-col gap-s4">
          <Input
            type="password"
            autoFocus
            autoComplete="current-password"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            error={erro}
            aria-label="Senha"
          />
          <Button type="submit" variant="primary" className="w-full justify-center" disabled={carregando}>
            {carregando ? 'Entrando…' : 'Entrar'}
          </Button>
        </div>
      </form>
    </div>
  );
}
